import React from 'react';
import { getContrastColor } from '../api/rangesApi';
import '../styles/ActionSelector.css';

const ActionSelector = ({ actions, onActionsChange, selectedAction, onSelectAction, readOnly }) => {
  const handlePercentageChange = (actionId, delta) => {
    if (readOnly) return;
    const newActions = actions.map(action => {
      if (action.id === actionId) {
        const newPercentage = Math.max(0, Math.min(100, action.percentage + delta));
        return { ...action, percentage: newPercentage };
      }
      return action;
    });
    
    onActionsChange(newActions);
  };

  const setQuickPercentage = (actionId, value) => {
    if (readOnly) return;
    const newActions = actions.map(action => {
      if (action.id === actionId) {
        return { ...action, percentage: value };
      }
      return action;
    });
    
    onActionsChange(newActions);
  };

  const handleNameChange = (actionId, newName) => {
    if (readOnly) return;
    const newActions = actions.map(action => {
      if (action.id === actionId) {
        return { ...action, name: newName };
      }
      return action;
    });
    onActionsChange(newActions);
  };

  return (
    <div className="action-selector">
      <div className="action-cards">
        {actions.map((action) => {
          const textColor = getContrastColor(action.color);
          return (
          <div
            key={action.id}
            className={`action-card ${selectedAction === action.id ? 'selected' : ''}`}
            style={{ 
              backgroundColor: action.color,
              borderColor: selectedAction === action.id ? '#fff' : 'transparent',
              color: textColor
            }}
            onClick={() => onSelectAction(action.id)}
          >
            <input
              className="action-name-input"
              value={action.name}
              onChange={(e) => handleNameChange(action.id, e.target.value)}
              onClick={(e) => e.stopPropagation()}
              style={{ color: textColor }}
              disabled={readOnly}
            />
            
            <div className="percentage-controls">
              <button 
                className="percentage-btn"
                onClick={(e) => { e.stopPropagation(); handlePercentageChange(action.id, -5); }}
                disabled={readOnly}
              >
                −
              </button>
              <span className="percentage-value">{action.percentage}</span>
              <button 
                className="percentage-btn"
                onClick={(e) => { e.stopPropagation(); handlePercentageChange(action.id, 5); }}
                disabled={readOnly}
              >
                +
              </button>
            </div>
            
            <div className="quick-percentages">
              {[0, 25, 50, 75, 100].map((val) => (
                <button
                  key={val}
                  className={`quick-btn ${action.percentage === val ? 'active' : ''}`}
                  onClick={(e) => { e.stopPropagation(); setQuickPercentage(action.id, val); }}
                  disabled={readOnly}
                >
                  {val}
                </button>
              ))}
            </div>
          </div>
        );})}
      </div>
      
      <div className="selection-indicator">
        <div 
          className="indicator-bar"
          style={{ backgroundColor: actions.find(a => a.id === selectedAction)?.color }}
        />
        <span>Выбрано: <strong>{actions.find(a => a.id === selectedAction)?.name}</strong></span>
      </div>
      
      <div className={`total-indicator ${actions.reduce((sum, a) => sum + a.percentage, 0) === 100 ? 'valid' : 'invalid'}`}>
        Сумма: <strong>{actions.reduce((sum, a) => sum + a.percentage, 0)}%</strong>
        {actions.reduce((sum, a) => sum + a.percentage, 0) !== 100 && <span> (должно быть 100%)</span>}
      </div>
    </div>
  );
};

export default ActionSelector;

